import AsideRightBox from "../../../../global/components/AsideRightBox/AsideRightBox.vue";
import PuxTranslate from "../../../../global/components/PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "AntragWarningBoxNegativGeprueft",
  components: {
    AsideRightBox,
    PuxTranslate,
  },
  props: {
    isNegativGeprueft: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      optionsAsideRightBoxWarning: {
        icon: "warning",
        toggle: false,
      },
    };
  },
};
